module.exports = __webpack_public_path__ + "img/软件管理.e4f10ef1.png";